export type CadastroAlunoFieldErrors = {
  name?: string;
  email?: string;
  password?: string;
  birth_date?: string;
};

export type CadastroAlunoFormValues = {
  name: string;
  email: string;
  password: string;
  birth_date: string;
};

export const APP_STORE_URL =
  "https://apps.apple.com/br/app/easyfit/id1473322908";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=br.com.easyfit.app";

export function getPasswordStrength(password: string): {
  score: 0 | 1 | 2 | 3;
  label: string;
} {
  if (!password) return { score: 0, label: "" };
  let score = 0;
  if (password.length >= 8) score += 1;
  if (/[A-Za-z]/.test(password) && /\d/.test(password)) score += 1;
  if (password.length >= 12 || /[^A-Za-z0-9]/.test(password)) score += 1;
  const labels = ["", "Fraca", "Boa", "Forte"] as const;
  return { score: score as 0 | 1 | 2 | 3, label: labels[score] };
}

/** Idade em anos completos a partir de YYYY-MM-DD (local). */
export function ageFromBirthDate(birthDate: string): number | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(birthDate)) return null;
  const [y, m, d] = birthDate.split("-").map(Number);
  const dob = new Date(y, m - 1, d);
  if (
    Number.isNaN(dob.getTime()) ||
    dob.getFullYear() !== y ||
    dob.getMonth() !== m - 1 ||
    dob.getDate() !== d
  ) {
    return null;
  }
  const today = new Date();
  let age = today.getFullYear() - y;
  const beforeBirthday =
    today.getMonth() < m - 1 ||
    (today.getMonth() === m - 1 && today.getDate() < d);
  if (beforeBirthday) age -= 1;
  return age;
}

export function validateCadastroAlunoForm(
  values: CadastroAlunoFormValues,
): CadastroAlunoFieldErrors {
  const next: CadastroAlunoFieldErrors = {};
  const trimmedName = values.name.trim();
  const trimmedEmail = values.email.trim().toLowerCase();
  const age = ageFromBirthDate(values.birth_date.trim());

  if (!trimmedName || trimmedName.split(/\s+/).length < 2) {
    next.name = "Informe nome e sobrenome.";
  }
  if (!trimmedEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
    next.email = "Informe um e-mail válido.";
  }
  if (values.password.length < 8) {
    next.password = "Mínimo de 8 caracteres.";
  } else if (
    !/[A-Za-z]/.test(values.password) ||
    !/\d/.test(values.password)
  ) {
    next.password = "Use letras e números.";
  }
  if (age == null) {
    next.birth_date = "Informe uma data de nascimento válida.";
  } else if (age < 10 || age > 100) {
    next.birth_date = "Idade deve estar entre 10 e 100 anos.";
  }

  return next;
}

export function buildInviteCadastroUrl(
  origin: string,
  minhaUrl: string | null | undefined,
  userId: string | number,
): string {
  const slug = (minhaUrl && minhaUrl.trim()) || String(userId);
  return `${origin.replace(/\/$/, "")}/c/${slug}`;
}
